export default "__VITE_ASSET__d7170e31__"